export const keyMap = {
  'title': 'homeConfig',
  'backgroundColor': 'homeConfig',
  'backgroundImg': 'homeConfig',
  'formBackgroundColor': 'formPageConfig',
  'formBackgroundImg': 'formPageConfig',
  'margin': 'formPageConfig',
  'padding': 'formPageConfig',
  'buttonTitle': 'subButtonConfig',
  'fontWeight': 'subButtonConfig',
  'buttonColor': 'subButtonConfig',
  'buttonBackgroundColor': 'subButtonConfig',
  'borderRadius': 'subButtonConfig',
  'inputStyle':'formItemConfig',  
  'formItemMargin': 'formItemConfig',
  'fontSize': 'formItemConfig',
  'itemFontWeight': 'formItemConfig',
  'formItemColor': 'formItemConfig',
  'itemTitleToCmpDistance': 'formItemConfig',
  'itemLayout': 'formItemConfig',
  'inputItemBorderColor': 'formItemConfig',
  'inputItemBottomLineColor': 'formItemConfig',
  'inputBackgroundColor': 'formItemConfig',
  // 'switch': 'formProtocolConfig',
  // 'title': 'formProtocolConfig',
  // 'context': 'formProtocolConfig'
}